var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgExperiments28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67127 21.4033C2.2443 21.7828 2 22.3269 2 22.8981V25C2 25.5523 2.44772 26 3 26H25C25.5523 26 26 25.5523 26 25V22.8981C26 22.3269 25.7557 21.7828 25.3287 21.4033L17.3356 14.2983C17.1221 14.1086 17 13.8366 17 13.5509V3H11V13.5509C11 13.8366 10.8779 14.1086 10.6644 14.2983L2.67127 21.4033ZM13 5V13.5509C13 14.4078 12.6336 15.2239 11.9931 15.7932L4 22.8981L4 24H24V22.8981L16.0069 15.7932C15.3664 15.2239 15 14.4078 15 13.5509V5H13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4C9 3.44772 9.44772 3 10 3H18C18.5523 3 19 3.44772 19 4C19 4.55228 18.5523 5 18 5H10C9.44772 5 9 4.55228 9 4Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExperiments28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;